import { AssetEvent } from './asset.event';
import { EventRegistry } from '../../../../../domain/event/event.registry';
export class AssetDeletedEvent extends AssetEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.assetClassId}/asset/${payload.id}`,
            type: AssetDeletedEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
AssetDeletedEvent.type = 'com.treeplotter.api.asset.deleted.v1';
EventRegistry.register(AssetDeletedEvent.type, AssetDeletedEvent);
//# sourceMappingURL=asset-deleted.event.js.map